/**
 * Marcom Module — Page Catalog Configuration
 * 
 * PORTABILITY: This file defines the available pages for Marcom.
 * When deploying to another platform (e.g., Tapelligence), 
 * replace this file with the target platform's page catalog.
 */
export const MARCO_PAGES = [
  {
    id: 'home',
    route: '/',
    titleEn: 'Home',
    titleFr: 'Accueil',
    descEn: 'Intelligence Hub — Real-time guest communication overview',
    descFr: 'Hub Intelligence — Apercu de la communication en temps reel',
    category: 'overview',
    color: 'bg-wine/20 border-wine/30',
    thumbnail: '/thumbnails/home.jpg',
  },
  {
    id: 'platform',
    route: '/platform',
    titleEn: 'Platform',
    titleFr: 'Plateforme',
    descEn: 'Complete system overview with zero POS integration',
    descFr: 'Apercu complet du systeme sans integration POS',
    category: 'core',
    color: 'bg-wine/20 border-wine/30',
    thumbnail: '/thumbnails/platform.jpg',
  },
  {
    id: 'positive-reviews',
    route: '/positive-reviews',
    titleEn: 'Positive Reviews',
    titleFr: 'Avis Positifs',
    descEn: 'Capture positive guest experiences and strengthen reputation',
    descFr: 'Capturez les experiences positives et renforcez la reputation',
    category: 'capabilities',
    color: 'bg-green-500/20 border-green-500/30',
    thumbnail: '/thumbnails/positive-reviews.jpg',
  },
  {
    id: 'b-heard',
    route: '/b-heard',
    titleEn: 'B-Heard',
    titleFr: 'B-Heard',
    descEn: 'A private voice for guests, and the chance to recover service before it goes public.',
    descFr: 'Une voix privée pour les clients, et la chance de récupérer le service avant que ça ne devienne public.',
    category: 'capabilities',
    color: 'bg-blue-500/20 border-blue-500/30',
    thumbnail: '/thumbnails/review-shield.jpg',
  },
  {
    id: 'global-review',
    route: '/global-review',
    titleEn: 'Global Review',
    titleFr: 'Avis Global',
    descEn: 'Multi-location reputation management',
    descFr: 'Gestion de la reputation multi-emplacements',
    category: 'capabilities',
    color: 'bg-wine/20 border-wine/30',
    thumbnail: '/thumbnails/global-review.jpg',
  },
  {
    id: 'rr360',
    route: '/rr360',
    titleEn: 'R&R 360 — Reward & Resolve',
    titleFr: 'R&R 360 — Recompense & Resolution',
    descEn: 'Staff recognition, service recovery, and the digital recovery bank',
    descFr: 'Reconnaissance du personnel, recuperation de service et banque de recuperation',
    category: 'capabilities',
    color: 'bg-wine/20 border-wine/30',
    thumbnail: '/thumbnails/rr360.jpg',
  },
  {
    id: 'guest-communication',
    route: '/guest-communication',
    titleEn: 'Guest Communication',
    titleFr: 'Communication Invites',
    descEn: 'Real-time alerts and direct guest line',
    descFr: 'Alertes en temps reel et ligne directe invites',
    category: 'capabilities',
    color: 'bg-orange-500/20 border-orange-500/30',
    thumbnail: '/thumbnails/guest-communication.jpg',
  },
  {
    id: 'insights',
    route: '/insights',
    titleEn: 'Insights & Reporting',
    titleFr: 'Apercuts & Rapports',
    descEn: 'Operational intelligence with trends and signals',
    descFr: 'Intelligence operationnelle avec tendances et signaux',
    category: 'capabilities',
    color: 'bg-wine/20 border-wine/30',
    thumbnail: '/thumbnails/insights.jpg',
  },
  {
    id: 'hardware',
    route: '/hardware',
    titleEn: 'Hardware',
    titleFr: 'Materiel',
    descEn: 'Tap Engine Cards with custom branding',
    descFr: 'Cartes Tap Engine avec image de marque',
    category: 'infrastructure',
    color: 'bg-wine/20 border-wine/30',
    thumbnail: '/thumbnails/hardware.jpg',
  },
  {
    id: 'implementation',
    route: '/implementation',
    titleEn: 'Implementation',
    titleFr: 'Implementation',
    descEn: 'Simple deployment, minimal training, fast rollout',
    descFr: 'Deploiement simple, formation minimale, lancement rapide',
    category: 'infrastructure',
    color: 'bg-blue-500/20 border-blue-500/30',
    thumbnail: '/thumbnails/implementation.jpg',
  },
  {
    id: 'contact',
    route: '/contact',
    titleEn: 'Contact / Request a Demo',
    titleFr: 'Contact / Demander une Demo',
    descEn: 'Get in touch to schedule a live demo',
    descFr: 'Contactez-nous pour planifier une demo',
    category: 'other',
    color: 'bg-wine/20 border-wine/30',
    thumbnail: '/thumbnails/contact.jpg',
  },
];

export const PAGE_CATEGORIES = {
  overview: { labelEn: 'Overview', labelFr: 'Apercu' },
  core: { labelEn: 'Core Platform', labelFr: 'Plateforme Principale' },
  capabilities: { labelEn: 'Capabilities', labelFr: 'Capacites' },
  infrastructure: { labelEn: 'Infrastructure', labelFr: 'Infrastructure' },
  other: { labelEn: 'Other', labelFr: 'Autre' },
};
